/* istanbul ignore file */
import { Navigate, Router, Route } from 'framework/routing';
import { Routes } from 'react-router-dom';
import { ONE_STOP_PATH } from 'domain/shared/oneStop';
import { useAuthorization } from 'framework/authorization';
import { EMPLOYEE_READ_ONE_STOP } from './OneStopRouter';
import { HANDBOOK_PATH } from 'domain/shared/core/sharedRouteConstants';
import { ROOT_PATH } from 'infrastructure/constants';

const REDIRECT_PATH = ONE_STOP_PATH;

const RedirectToOneStop: Router = () => {
  const { isGranted } = useAuthorization();
  const isOnlyHandbook = !isGranted(EMPLOYEE_READ_ONE_STOP);

  return (
    <Routes>
      <Route path={ROOT_PATH} element={<Navigate to={isOnlyHandbook ? HANDBOOK_PATH : REDIRECT_PATH} replace />} />
    </Routes>
  );
};

RedirectToOneStop.getRouterPath = () => ROOT_PATH;

export default RedirectToOneStop;
